// @flow
// import stores from './stores.data';
import { ofType } from 'redux-observable';
import { catchError, debounceTime, map, mergeMap } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { push } from 'react-router-redux';
import { getStoreApi, endpoints, getUserWishListApi } from './api';
import update from 'immutability-helper';

import type { OnlineStore, WishList, WishListItem } from '../../entities';
import type { HTTPError } from '../../error';
import type { Observable } from 'rxjs';
import { encodeProduct } from '../wish-list/utils/encode';
import { setNewAlert } from '../alert/duck';

type StoreAction = {
  +type: string;
  +name?: string;
  +store?: OnlineStore[];
  +error?: HTTPError;
  +nameSlug?: string;
  +userId?: string;
  +wishList?: WishList;
};

export type StoreState = {
  +isFetchingStore?: boolean;
  +fetchStoreError?: HTTPError;
  +store?: OnlineStore[];
  +isFetchingWishList1?: boolean;
  +isFetchingWishList2?: boolean;
  +wishList1?: WishList;
  +wishList2?: WishList;
  +fetchWishList1Error?: HTTPError;
  +fetchWishList2Error?: HTTPError;
};

//Actions
const STORE_FETCH_REQUEST = 'STORE_FETCH_REQUEST';
const STORE_FETCH_SUCCESS = 'STORE_FETCH_SUCCESS';
const STORE_FETCH_ERROR = 'STORE_FETCH_ERROR';

const WISH_LIST_FETCH_USER_WISH_LIST_1_REQUEST = 'WISH_LIST_FETCH_USER_WISH_LIST_1_REQUEST';
const WISH_LIST_FETCH_USER_WISH_LIST_1_SUCCESS = 'WISH_LIST_FETCH_USER_WISH_LIST_1_SUCCESS';
const WISH_LIST_FETCH_USER_WISH_LIST_1_ERROR = 'WISH_LIST_FETCH_USER_WISH_LIST_1_ERROR';

const WISH_LIST_FETCH_USER_WISH_LIST_2_REQUEST = 'WISH_LIST_FETCH_USER_WISH_LIST_2_REQUEST';
const WISH_LIST_FETCH_USER_WISH_LIST_2_SUCCESS = 'WISH_LIST_FETCH_USER_WISH_LIST_2_SUCCESS';
const WISH_LIST_FETCH_USER_WISH_LIST_2_ERROR = 'WISH_LIST_FETCH_USER_WISH_LIST_2_ERROR';

const STORE_RESET_STATE = 'STORE_RESET_STATE';

export function fetchStore(name: string): StoreAction {
  return {
    type: STORE_FETCH_REQUEST,
    name,
  };
}

export function fetchStoreSuccess(store: OnlineStore): StoreAction {
  return {
    type: STORE_FETCH_SUCCESS,
    store,
  };
}

export function fetchStoreErrorFn(error: HTTPError): StoreAction {
  return {
    type: STORE_FETCH_ERROR,
    error,
  };
}

export function getUserWishList1(userId: string, nameSlug: string): StoreAction {
  return {
    type: WISH_LIST_FETCH_USER_WISH_LIST_1_REQUEST,
    userId,
    nameSlug,
  };
}

export function getUserWishList1Success(wishList: any): StoreAction {
  return {
    type: WISH_LIST_FETCH_USER_WISH_LIST_1_SUCCESS,
    wishList,
  };
}

export function getUserWishList1Error(error: HTTPError): StoreAction {
  return {
    type: WISH_LIST_FETCH_USER_WISH_LIST_1_ERROR,
    error,
  };
}

export function getUserWishList2(userId: string, nameSlug: string): StoreAction {
  return {
    type: WISH_LIST_FETCH_USER_WISH_LIST_2_REQUEST,
    userId,
    nameSlug,
  };
}

export function getUserWishList2Success(wishList: any): StoreAction {
  return {
    type: WISH_LIST_FETCH_USER_WISH_LIST_2_SUCCESS,
    wishList,
  };
}

export function getUserWishList2Error(error: HTTPError): StoreAction {
  return {
    type: WISH_LIST_FETCH_USER_WISH_LIST_2_ERROR,
    error,
  };
}


export function resetState() {
  return {
    type: STORE_RESET_STATE,
  };
}

export const actions = {
  STORE_FETCH_REQUEST,
  STORE_FETCH_SUCCESS,
  STORE_FETCH_ERROR,
  STORE_RESET_STATE,
  WISH_LIST_FETCH_USER_WISH_LIST_1_REQUEST,
  WISH_LIST_FETCH_USER_WISH_LIST_1_SUCCESS,
  WISH_LIST_FETCH_USER_WISH_LIST_1_ERROR,
  WISH_LIST_FETCH_USER_WISH_LIST_2_REQUEST,
  WISH_LIST_FETCH_USER_WISH_LIST_2_SUCCESS,
  WISH_LIST_FETCH_USER_WISH_LIST_2_ERROR,
  fetchStore,
  fetchStoreSuccess,
  fetchStoreErrorFn,
  getUserWishList1,
  getUserWishList1Success,
  getUserWishList1Error,
  getUserWishList2,
  getUserWishList2Success,
  getUserWishList2Error,
  resetState,
};

/*function compareAsc(a: Store, b: Store) {
  if (a.value > b.value) {
    return 1;
  }
  if (a.value < b.value) {
    return -1;
  }
  return 0;
}

function compareDesc(a: Store, b: Store) {
  if (a.value < b.value) {
    return 1;
  }
  if (a.value > b.value) {
    return -1;
  }
  return 0;
}*/

// export const SORTED_STORES = stores.sort(compareAsc);
export const initialState: StoreState = {};

export default function reducer(state: StoreState = initialState,
                                action: StoreAction): StoreState {
  switch (action.type) {
    case STORE_FETCH_REQUEST:
      return update(state, {
        isFetchingStore: { $set: true },
        $unset: ['fetchStoreError'],
      });
    case STORE_FETCH_SUCCESS:
      return update(state, {
        store: { $set: action.store },
        $unset: ['isFetchingStore'],
      });
    case STORE_FETCH_ERROR:
      return update(state, {
        fetchStoreError: { $set: action.error },
        $unset: ['isFetchingStore'],
      });
    case WISH_LIST_FETCH_USER_WISH_LIST_1_REQUEST:
      return update(state, {
        isFetchingWishList1: { $set: true },
        $unset: ['fetchWishList1Error'],
      });
    case WISH_LIST_FETCH_USER_WISH_LIST_1_SUCCESS:
      return update(state, {
        wishList1: { $set: action.wishList },
        $unset: ['isFetchingWishList1'],
      });
    case WISH_LIST_FETCH_USER_WISH_LIST_1_ERROR:
      return update(state, {
        $unset: ['isFetchingWishList1'],
        fetchWishList1Error: { $set: action.error },
      });
    case WISH_LIST_FETCH_USER_WISH_LIST_2_REQUEST:
      return update(state, {
        isFetchingWishList2: { $set: true },
        $unset: ['fetchWishList2Error'],
      });
    case WISH_LIST_FETCH_USER_WISH_LIST_2_SUCCESS:
      return update(state, {
        wishList2: { $set: action.wishList },
        $unset: ['isFetchingWishList2'],
      });
    case WISH_LIST_FETCH_USER_WISH_LIST_2_ERROR:
      return update(state, {
        $unset: ['isFetchingWishList2'],
        fetchWishList2Error: { $set: action.error },
      });
    case STORE_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

// epics
export function fetchStoreEpic(action$: Observable<StoreAction>): Observable<StoreAction> {
  return action$.pipe(
    ofType(STORE_FETCH_REQUEST),
    mergeMap(({ name }: StoreAction) =>
      getStoreApi(undefined, {
        route: endpoints.GET_STORE.replace(':name', `${name || ''}`),
      }).pipe(
        map((store: OnlineStore) => fetchStoreSuccess(store)),
        catchError((e: HTTPError) => {
          if (e.code === 404) {
            return of(push('/stores'));
          }
          return of(fetchStoreErrorFn(e));
        })
      )),
  );
}

export function StoreGetUserWishList1Epic(action$: Observable<StoreAction>): Observable<StoreAction> {
  return action$.pipe(
    ofType(WISH_LIST_FETCH_USER_WISH_LIST_1_REQUEST),
    debounceTime(600),
    mergeMap(({ userId, nameSlug }) => getUserWishListApi({
        sort: 'UPDATED_AT',
        order: 'DESC',
      }, {
        route: endpoints.GET_USER_WISH_LIST
          .replace(':userId', userId)
          .replace(':nameSlug', nameSlug)
      }).pipe(
      map((response: WishList) => {
        const newItems = response.items.map((item: WishListItem) => ({ ...item, encoded: encodeProduct(item) }));
        return getUserWishList1Success({ ...response, items: newItems });
      }),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(getUserWishList1Error(e),
            setNewAlert('store', 'error', undefined, 'httpErrors.fetch.500'),
          );
        } else if (e.code === 400) {
          return of(getUserWishList1Error(e),
            setNewAlert('store', 'error', undefined, 'httpErrors.fetch.400'),
          );
        } else if (e.code === 404) {
          return of(getUserWishList1Error(e),
            //push('/'),
          );
        }
        return of(getUserWishList1Error(e));
      }))
    ));
}

export function StoreGetUserWishList2Epic(action$: Observable<StoreAction>): Observable<StoreAction> {
  return action$.pipe(
    ofType(WISH_LIST_FETCH_USER_WISH_LIST_2_REQUEST),
    debounceTime(600),
    mergeMap(({ userId, nameSlug }) => getUserWishListApi({
        sort: 'UPDATED_AT',
        order: 'DESC',
      }, {
        route: endpoints.GET_USER_WISH_LIST
          .replace(':userId', userId)
          .replace(':nameSlug', nameSlug)
      }).pipe(
      map((response: WishList) => {
        const newItems = response.items.map((item: WishListItem) => ({ ...item, encoded: encodeProduct(item) }));
        return getUserWishList2Success({ ...response, items: newItems });
      }),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(getUserWishList2Error(e),
            setNewAlert('store', 'error', undefined, 'httpErrors.fetch.500'),
          );
        } else if (e.code === 400) {
          return of(getUserWishList2Error(e),
            setNewAlert('store', 'error', undefined, 'httpErrors.fetch.400'),
          );
        } else if (e.code === 404) {
          return of(getUserWishList2Error(e),
            //push('/'),
          );
        }
        return of(getUserWishList2Error(e));
      }))
    ));
}




// WEBPACK FOOTER //
// ./src/modules/store/duck.js